import { useState, useEffect, useRef } from "react";
import API from "../lib/api";

/**
 * Renders admin-managed ad codes for a given position/page slot.
 * Executes <script> tags (ad-network snippets, iframes, etc.) by re-creating
 * them as real DOM script elements (innerHTML alone does not run scripts).
 */
export default function AdCodeSlot({ position = "sidebar", page = "all" }) {
  const [codes, setCodes] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    API.get("/ads/codes")
      .then((r) => {
        const filtered = (r.data.codes || []).filter(
          (c) =>
            (c.position === position || c.position === "all") &&
            (c.page === page || c.page === "all")
        );
        setCodes(filtered);
      })
      .catch(() => {});
  }, [position, page]);

  useEffect(() => {
    if (!containerRef.current || codes.length === 0) return;
    const container = containerRef.current;
    container.textContent = "";
    codes.forEach((ad) => {
      if (!ad.code) return;
      const temp = document.createElement("div");
      temp.innerHTML = ad.code;
      Array.from(temp.childNodes).forEach((node) => {
        if (node.nodeType === 1 && node.tagName === "SCRIPT") {
          const s = document.createElement("script");
          Array.from(node.attributes).forEach((a) => s.setAttribute(a.name, a.value));
          s.text = node.textContent || "";
          container.appendChild(s);
        } else {
          const clone = node.cloneNode(true);
          if (node.nodeType === 1) {
            const nested = clone.querySelectorAll ? clone.querySelectorAll("script") : [];
            nested.forEach((orig) => {
              const s = document.createElement("script");
              Array.from(orig.attributes).forEach((a) => s.setAttribute(a.name, a.value));
              s.text = orig.textContent || "";
              orig.replaceWith(s);
            });
          }
          container.appendChild(clone);
        }
      });
    });
    return () => {
      if (container) container.textContent = "";
    };
  }, [codes]);

  if (codes.length === 0) return null;

  return <div ref={containerRef} className="ad-slot mb-4" data-testid={`ad-slot-${position}-${page}`} />;
}
